import React, { useState, useEffect, useContext } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
  List,
  ListItem,
  ListItemText,
  Collapse,
  IconButton,
  Grid 
} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import _ from 'lodash';
import { differenceInDays, addDays, isSameDay, isWithinInterval, format, parseISO } from 'date-fns';


import config from '../../../../config/config.json'
import withAlert from '../../../../hoc/withAlert'
import Day from '../Day'

const useStyles = makeStyles(theme => ({
  paper: {
    display: 'flex',
    border: `1px solid ${theme.palette.divider}`,
    flexWrap: 'wrap',
  },
  divider: {
    alignSelf: 'stretch',
    height: 'auto',
    margin: theme.spacing(1, 0.5),
  },
}));



const Meeting = props => {
  // Заберем из HOC нужные методы для показа алерта
  const {setSnackMessage, setSnackType, setOpenSnack} = props

  // console.log('orderContext',orderContext.actionType);
  const {meeting} = props;
  const { id, name, days } = meeting
  const classes = useStyles();

// Состояние открыт закырт
  const [open, setOpen] = useState(false);


  //  Обработчик свертывания развертывания
  const handleClick = () => {
    setOpen(!open);
  };

  // Состояние при старте
  useEffect(() => {
    if(meeting){
      // console.log('meeting', meeting);
      // const daysDiff = differenceInDays(parseISO(end), parseISO(start)) + 1
      // console.log('daysDiff',daysDiff);
      // const days = _.range(
      //   0,
      //   daysDiff,
      //   1
      //   ).map(daysNum => {
      //     const currentDay = addDays(parseISO(start), daysNum);
      //     return currentDay
      //   })
      //   console.log('days',days);

    }
  }, [meeting]);

  


  return (
    <React.Fragment>

    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      className={classes.root}
      dense={false}
    >
      <ListItem button onClick={handleClick}>
        {open ? <ExpandLess /> : <ExpandMore />}
        <ListItemText primary={name} />
      </ListItem>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding dense={false}>
        {/* <ListItem role={undefined} dense>
        </ListItem> */}
          {/* <Day/> */}
          {
          days.map((d, index) => (
            <Day
              key={index}
              day={d}
              meetingId={id}
            />
          )
          )}

        </List>

      </Collapse>

    </List>
    </React.Fragment>
  );
};


export default withAlert(Meeting);
